import React from 'react';

/*
  ErrorBoundary — stops the "white screen of death".
  Without this, ANY uncaught render error anywhere in the tree unmounts the
  whole app and leaves a blank white page (React's default). Wrapping the app
  root means a crash instead shows a recoverable "Something went wrong" screen
  with a Reload button — and, crucially, transient errors (a LiveKit connect
  race, a bad token, a momentary undefined) become recoverable instead of fatal.
*/
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Part 5a (Feb 19, 2026): print error.message + component stack so
    // the ErrorBoundary tells us EXACTLY what crashed instead of the
    // opaque "caught render crash: [Object]" prod devs used to see.
    try {
      console.error(
        '[ErrorBoundary] caught render crash:',
        error?.message || String(error),
        '\n[ErrorBoundary] stack:', error?.stack,
        '\n[ErrorBoundary] componentStack:', info?.componentStack,
      );
    } catch {
      console.error('[ErrorBoundary] caught render crash:', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#070B11', color: '#EAF1F5', padding: 24, textAlign: 'center',
          fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",system-ui,sans-serif',
        }}>
          <div style={{ maxWidth: 420 }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
            <h1 style={{ fontSize: 22, fontWeight: 800, margin: '0 0 8px' }}>Something went wrong</h1>
            <p style={{ color: '#8A97A6', fontSize: 15, lineHeight: 1.5, margin: '0 0 20px' }}>
              This page hit an error and couldn’t finish loading. Reloading usually fixes it.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(90deg,#34E3A4,#22C98C)', color: '#062015', fontWeight: 800,
                border: 'none', borderRadius: 999, padding: '12px 26px', fontSize: 15, cursor: 'pointer',
              }}
            >
              Reload
            </button>
            <div style={{ marginTop: 16 }}>
              <a href="/" style={{ color: '#34E3A4', fontSize: 13, textDecoration: 'none' }}>Go to GEMS Live home</a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
